<template>
    <div>
        <div v-if="isLoaded && isHaveItem">
            <CampaignItem
                v-for="(campaign, k) in campaigns"
                :key="k"
                :index="k"
                :campaign="campaign"
            >

            </CampaignItem>
        </div>
        <div class="no-list-campaign" v-if="isLoaded && !isHaveItem">
            <div class="icon-no-list">
                <img src="@/assets/icon/icon-nodata-white.svg" />
            </div>
            <div>ไม่พบข้อมูล</div>
        </div> 
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
import CampaignItem from "./CampaignItem.vue";
export default {
    name: "CampaignList",
    components: {
        CampaignItem
    },
    props: {
        isLoading: Boolean,
        initListConfig: Object,
    },
    data: function () {
        return {
            campaigns: [],
            isLoaded: false,
            listConfig: {},
            isHaveItem: false,
        };
    },
    created: function () {
        this.listConfig = this.initListConfig;
    },
    mounted: function () {
        this.getList();
    },
    methods: {
        getList: function () {
            if (!this.listConfig.strConfigList)
                return;
            this.showLoading();
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig, null).subscribe((campaigns) => {
                this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                //check is there are more campaign.
                if (campaigns &&
                    campaigns.length < this.listConfig.defaultTopAmount)
                    this.listConfig.isSeeMoreEnable = false;
                //reinitialize list if no skip.
                if (this.listConfig.intSkip ==
                    this.listConfig.defaultTopAmount)
                    this.campaigns = [];
                for (var campaign of campaigns) {
                    //TODO: Add GA Tracking.
                    this.campaigns.push(campaign);
                }
                this.isLoaded = true;
                this.isHaveItem = this.campaigns.length > 0
                    ? true
                    : false;
                
                this.hideLoading();
            }, (err) => {
                this.isLoaded = true;
                this.isHaveItem = false;
                this.hideLoading();
                console.log(err);
            });
        },
        //utilities
        hideLoading: function () {
            this.toggleLoading(false);
        },
        showLoading: function () {
            if (this.isLoading)
                return true;
            this.toggleLoading(true);
            return false;
        },
        toggleLoading: function (isLoading) {
            this.$emit("toggleLoading", isLoading);
        }
    },

}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "../../List/component/campaignlist.scss";
</style>